import { render, staticRenderFns } from "./MetastaticStomachCancer.vue?vue&type=template&id=800bf6ba&scoped=true"
import script from "./MetastaticStomachCancer.vue?vue&type=script&lang=js"
export * from "./MetastaticStomachCancer.vue?vue&type=script&lang=js"
import style0 from "./MetastaticStomachCancer.vue?vue&type=style&index=0&id=800bf6ba&prod&lang=scss&scoped=true"
import style1 from "./MetastaticStomachCancer.vue?vue&type=style&index=1&id=800bf6ba&prod&lang=scss&scoped=true"
import style2 from "./MetastaticStomachCancer.vue?vue&type=style&index=2&id=800bf6ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800bf6ba",
  null
  
)

export default component.exports